/* eslint-disable unicorn/filename-case */
import _ from 'lodash';

const areAddressesEqual = (address1, address2) => {

    if (address1 && address2) {
        if (address1.addressLine1 !== address2.addressLine1) {
            return false;
        }

        if (address1.city !== address2.city) {
            return false;
        }

        if (address1.postalCode !== address2.postalCode) {
            return false;
        }

        if (address1.country !== address2.country) {
            return false;
        }

        if (address1.state !== address2.state) {
            return false;
        }

        return true;
    }

    if (_.isNil(address1) && _.isNil(address2)) {
        return true;
    }

    return false;
};





export default {
    areAddressesEqual,
};
